// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-02c06e71] .ag-header-cell-text{white-space:nowrap !important}", ""]);
// Exports
module.exports = exports;
